export default function moneyDisplayFilterFactory(CurrencyService, displayNumberFilter) {
  'ngInject';

  return function moneyDisplayFilter(amount, fractionAlwaysVisible = true) {
    const currency = CurrencyService.getOrgCurrency();
    const formattedAmount = displayNumberFilter(amount, fractionAlwaysVisible);

    if (currency.format) {
      return currency.format.replace('%d', formattedAmount);
    }

    return `${currency.symbol}${formattedAmount}`;
  };
}
